import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { UIContent } from "@/UIContent";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import { ActionMenu } from "oolib";
import {
  handleDeleteRow,
  handleDuplicateRow,
  handleInsertRowAfter,
  handleInsertRowBefore,
  handleClearRowContent,
} from "../../../handlers/handleRowActions";
import { commonRowColActionMenuStyles } from "../styled";

const StyledCustomSelectCompWrapper = styled.button`
  ${commonRowColActionMenuStyles}
  /* width: 1.5rem; */
  height: 2.5rem;
`;

// const CustomSelectComp =

export const RowActionsMenu = ({
  value,
  rowIdx,
  onChange,
  id,
  disableAddRow,
  setActionsActiveOnRow,
  rowActionsButtonWidth,
  conditionsToRender = true,
  blockConfig
}) => {
  const [actionMenuIsOpen, setActionMenuIsOpen] = useState(false)

  const isFirstMount = useRef(true)
  useEffect(() => {
    if(!isFirstMount.current){
      setActionsActiveOnRow(actionMenuIsOpen ? rowIdx : undefined)
    }else{
      isFirstMount.current = false
    }
  },[actionMenuIsOpen])

  // cuz if an actionmenu is open we want it to continue showing
  // on screen irrespective of other factors such as hover and such
  return (conditionsToRender || actionMenuIsOpen) && (
    <div
      style={{
        zIndex: 2,
        position: "absolute",
        top: "50%",
        left: 0,
        transform: "translate(-50%, -50%)",
      }}
    >
      <ActionMenu
        popOutOfOverflowHiddenParent
        align="left"
        setShowActions={(showActions) => {
          setActionMenuIsOpen(showActions)
        }}
        CustomSelectComp={({ active, onClick }) => {
          return (
            <StyledCustomSelectCompWrapper
              style={{ width: rowActionsButtonWidth + "px" }}
              onClick={onClick}
              active={active}
            >
              <DisplayIcon icon="DotsThreeVertical" size={16} />
            </StyledCustomSelectCompWrapper>
          );
        }}
        actions={[
          ...(!disableAddRow ? [
            {
              display: UIContent.SimpleTable.delete,
              onClick: () => handleDeleteRow({ value, rowIdx, onChange, id }),
            },
            {
              display: UIContent.SimpleTable.duplicate,
              onClick: () => handleDuplicateRow({ value, rowIdx, onChange, id }),
            },
            {
              display: UIContent.SimpleTable.insertRowBefore,
              onClick: () =>
                handleInsertRowBefore({ value, rowIdx, onChange, id, blockConfig }),
            },
            {
              display: UIContent.SimpleTable.insertRowAfter,
              onClick: () =>
                handleInsertRowAfter({ value, rowIdx, onChange, id, blockConfig }),
            },
          ] : []),
          {
            display: UIContent.SimpleTable.clearContent,
            onClick: () =>
              handleClearRowContent({ value, rowIdx, onChange, id, blockConfig }),
          },
        ]}
      />
    </div>
  );
};
